export default __webpack_public_path__ + "assets/mp3/f349ecee2078f5fcbe951f32df888dc3.mp3";